import styled from 'styled-components'
import { modalAppear } from '../../constants/animations'
import { GENERAL_COLORS } from '../../constants/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: ${p => p.containerWidth}px;
  min-height: ${p => p.autoHeight ? 'auto' : `${p.containerHeight}px`};
  overflow-y: auto;
  background-color: ${props => props.theme.color.backgroundRush};
  box-shadow: ${props => props.theme.shadow.xl};
  border-radius: 40px;
  animation: ${modalAppear} ${p => p.theme.duration.m} ease-in-out;
  padding: 40px;

  > h6 {
    margin-bottom: 10px;
  }

  > p {
    width: 100%;
  }
`

const Body = styled.div`
  margin-bottom: 20px;
  word-break: break-all;
  color: ${GENERAL_COLORS.gray};
  font-size: 12px;
`

const Buttons = styled.div`
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;

  button+button {
    margin-left: auto;
  }
`

export const Styled = {
  Container,
  Body,
  Buttons,
};
